<template>
  <el-row :gutter="20">
    <el-col style="text-align: center; background: #f4f4f5; font-size: 14px; padding: 20px">
      模板名称：
      <el-link type="primary" :underline="false" style="margin-top: -5px" href="javascript:;">
        {{ name }}
      </el-link>
      <template v-if="host.id">
        <div style="height: 10px" />
        部署至网站云：
        <el-link type="primary" :underline="false" style="margin-top: -5px" :href="getHostUrl()" target="_blank">
          {{ getUniqueName() }}
          <span v-if="host.nickName">（{{ host.nickName }}）</span>
        </el-link>
      </template>
    </el-col>
  </el-row>
  <div style="margin: 15px 30px 0">
    <template v-if="pageType === 'hosts'">
      <el-table :data="hosts" style="width: 100%" row-key="id">
        <el-table-column prop="siteName" label="网站云">
          <template #default="scope">
            <el-link
              type="primary"
              style="margin-right: 5px"
              :underline="false"
              :href="getUrl(scope.row.hostName, scope.row.nodeName, scope.row.isHongKong)"
              target="_blank"
            >
              {{ getUniqueName(scope.row) }}
            </el-link>
            <br v-if="scope.row.nickName" />
            <el-link :underline="false" @click.prevent>
              {{ scope.row.nickName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="100">
          <template #default="scope">
            <el-button-group>
              <el-button @click="btnHostClick(scope.row)">部 署</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template v-else-if="pageType === 'submit'">
      <el-form style="margin: 0 10px" ref="form" :model="form" label-position="left" label-width="120px">
        <el-form-item label="站点名称" prop="siteName" :rules="{ required: true, message: '请输入站点名称' }">
          <el-input v-model="form.siteName" placeholder="请输入站点名称"></el-input>
        </el-form-item>
        <el-form-item v-if="!rootExists" label="站点级别" prop="root" :rules="{ required: true, message: '请选择站点级别' }">
          <el-radio-group v-model="form.root">
            <el-radio :label="true">主站</el-radio>
            <el-radio :label="false">子站</el-radio>
          </el-radio-group>
          <div class="tips">主站文件夹路径为系统根目录</div>
        </el-form-item>
        <el-form-item v-if="!form.root" label="上级站点">
          <el-radio-group v-model="form.isParent">
            <el-radio :label="false">无上级站点</el-radio>
            <el-radio :label="true">选择上级站点</el-radio>
          </el-radio-group>
          <div class="tips">如需将站点文件夹放置在特定站点之下，请选择上级站点</div>
          <el-table
            v-if="form.isParent"
            :data="sites"
            style="width: 100%"
            row-key="id"
            default-expand-all
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column prop="siteName" label="上级站点">
              <template #default="scope">
                <el-badge v-if="scope.row.root" type="danger" style="margin-top: 10px" value="主站">
                  <el-radio v-model="form.parentId" :label="scope.row.id">{{ scope.row.siteName }}</el-radio>
                </el-badge>
                <el-radio v-else v-model="form.parentId" :label="scope.row.id">{{ scope.row.siteName }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column prop="localUrl" label="站点文件夹" width="120"></el-table-column>
            <el-table-column prop="siteUrl" label="访问地址">
              <template #default="scope">
                <el-link :underline="false" type="primary" :href="getSitUrl(scope.row)" target="_blank">
                  {{ getSitUrl(scope.row) }}
                </el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item
          v-if="!form.root"
          label="文件夹名称"
          prop="siteDir"
          :rules="{ required: true, message: '请输入文件夹名称' }"
        >
          <el-input v-model="form.siteDir" placeholder="请输入文件夹名称"></el-input>
          <div class="tips">实际在服务器中保存此网站的文件夹名称，此路径必须以英文或拼音命名</div>
        </el-form-item>
        <el-divider></el-divider>

        <div class="el-dialog__footer">
          <el-button type="primary" @click="btnSubmitClick">部 署</el-button>
        </div>
      </el-form>
    </template>

    <template v-else-if="pageType == 'process'">
      <div style="margin: 1em 2em 2em 2em">
        <div style="padding: 5px">
          任务完成:
          <span>{{ Math.ceil((current * 100) / total) + '' }}</span>
          %
        </div>
        <div style="width: 100%; height: 25px; background: #eee">
          <div
            :style="{ width: Math.ceil((current * 100) / total) + '%', height: '25px', backgroundColor: '#67c23a' }"
          ></div>
        </div>
        <div class="tips" style="margin: 5px">{{ message || '任务初始化...' }}</div>
      </div>
    </template>

    <template v-else-if="pageType == 'error'">
      <el-alert title="错误提示" type="error" :description="errorMessage" show-icon></el-alert>
    </template>

    <template v-else-if="pageType == 'success'">
      <div role="alert" class="el-alert el-alert--success is-light">
        <i class="el-alert__icon el-icon-success is-big"></i>
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">模板部署成功</span>
          <p class="el-alert__description">
            恭喜，模板 {{ name }} 已成功部署至网站云 {{ getUniqueName() }}，访问地址：
            <el-link type="primary" :underline="false" target="_blank" style="margin-top: -5px" :href="getSitUrl(site)">
              {{ getSitUrl(site) }}
            </el-link>
            <el-divider></el-divider>
            <el-button type="primary" v-on:click="btnCloseClick">关 闭</el-button>
          </p>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import api from '@/api/my/templates';
import utils from '@/utils';
import { IHost, ISite } from '@/types/models';
import agentSites from '@/api/agent/sites';
import agentAddSite from '@/api/agent/addSite';
import agentProcess from '@/api/agent/process';
import { IElForm } from '@/types/element';

interface IForm {
  hostId: number;
  siteName: string;
  root: boolean;
  siteDir: string;
  isParent: boolean;
  parentId: number;
}

interface IState {
  pageType: string;
  hosts: IHost[];
  host: IHost;
  form: IForm;
  rootExists: boolean;
  sites: ISite[];
  guid: string;
  total: number;
  current: number;
  message: string;
  success: boolean;
  errorMessage: string;
  site: ISite;
}

export default defineComponent({
  name: 'Domains',
  emits: ['close'],
  props: {
    userName: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pageType: 'hosts',
      hosts: [],
      host: {} as IHost,
      form: {} as IForm,
      rootExists: false,
      sites: [],
      guid: '',
      total: 1,
      current: 0,
      message: '',
      success: false,
      errorMessage: '',
      site: {} as ISite,
    } as IState;
  },
  methods: {
    apiGet() {
      this.pageType = 'hosts';
      this.hosts = [];
      this.host = {} as IHost;
      this.form = {} as IForm;
      this.rootExists = false;
      this.sites = [];
      this.guid = '';
      this.total = 1;
      this.current = 0;
      this.message = '';
      this.success = false;
      this.errorMessage = '';
      this.site = {} as ISite;

      api.getHosts((res) => {
        if (!res) return;
        this.hosts = res.hosts;
        this.form = {} as IForm;
        this.sites = [];
      });
    },

    getUniqueName(host?: IHost) {
      return utils.getHostUniqueName(host || this.host);
    },

    getHostType(host: IHost) {
      return utils.getHostType(host.hostType);
    },

    formatDate(date: Date) {
      return utils.formatDate(date);
    },

    getUrl(hostName: string, nodeName: string, isHongKong: boolean): string {
      return utils.getHostUrl(hostName, nodeName, isHongKong);
    },

    getHostUrl(): string {
      return utils.getHostUrl(this.host.hostName, this.host.nodeName, this.host.isHongKong);
    },

    getSitUrl(site: ISite) {
      return utils.getSiteUrl(this.host, site);
    },

    btnHostClick(host: IHost) {
      this.host = host;
      agentSites.getSites(
        this.host.hostName,
        this.host.nodeName,
        this.host.isHongKong,
        {
          securityKey: this.host.securityKey,
        },
        (res) => {
          this.sites = res.sites;
          this.rootExists = res.rootSiteId > 0;
          this.form.root = !this.rootExists;
          this.form.isParent = false;
          this.form.parentId = 0;
          this.pageType = 'submit';
        },
      );
    },

    apiProcess() {
      if (this.success) return;
      this.pageType = 'process';

      agentProcess.process(
        this.host.hostName,
        this.host.nodeName,
        this.host.isHongKong,
        {
          securityKey: this.host.securityKey,
          guid: this.guid,
        },
        (res) => {
          if (this.success) return;

          this.total = res.total || 1;
          this.current = res.current;
          this.message = res.message;

          if (this.current > this.total) {
            this.current = this.total;
          }

          if (this.total > this.current) {
            setTimeout(() => {
              this.apiProcess();
            }, 3000);
          }
          utils.loading(false);
        },
      );
    },

    apiSubmit() {
      this.pageType = 'process';
      api.getTheme(
        {
          userName: this.userName,
          name: this.name,
        },
        (res) => {
          if (!res) return;
          this.guid = res.guid;

          const interval = setTimeout(() => {
            this.apiProcess();
          }, 3000);

          agentAddSite.addSite(
            this.host.hostName,
            this.host.nodeName,
            this.host.isHongKong,
            {
              securityKey: this.host.securityKey,
              siteName: this.form.siteName,
              root: this.form.root,
              parentId: this.form.isParent ? this.form.parentId : 0,
              siteDir: this.form.siteDir,
              themeDownloadUrl: res.themeDownloadUrl,
              guid: res.guid,
            },
            (res2) => {
              if (res2.site) {
                this.total = 1;
                this.current = 1;
                this.message = '站点创建成功！';
                this.success = true;
                this.pageType = 'success';
                this.site = res2.site;
              }
            },
            (errorMessage) => {
              clearTimeout(interval);
              this.pageType = 'submit';
              utils.loading(false);
              utils.error(errorMessage);
            },
          );
        },
      );
    },

    btnCloseClick() {
      this.$emit('close');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.apiSubmit();
        }
      });
    },
  },
  watch: {
    userName: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
    name: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.apiGet();
        }
      },
      deep: false,
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
